export enum DiscountType {
  BankAccount = 'BANK_ACCOUNT',
  Sustainability = 'SUSTAINABILITY'
}

export enum SustainabilityDiscount {
  A_OR_HIGHER = 'A_OR_HIGHER',
  B = 'B',
  NoDiscount = '-'
}
